import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CurrentPageWatcherService } from '../../shared/utils/CurrentPageWatcher';
import { LoginService } from "./login.service";
import { MessageCenter } from '../../shared/utils/MessagesCenter';
import { FormGroup, FormControl, Validators, FormBuilder, NgForm } from '@angular/forms';
import { ValidateUserWithPasswordRequestModel, ValidateUserWithPersonalInformationRequestModel, ValidateUserResponseModel, RequiredInformationModel, MessageModel } from '../../model/models';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { TransactionsService } from '../../transactions/transactions.service';
import * as $ from 'jquery';
import { StorageService } from '../../shared/security/StorageService';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
 
  loginform: FormGroup;
  firstTimeResetform: FormGroup;

  userName: FormControl= this.fb.control('', Validators.required);
  password: FormControl = this.fb.control('', Validators.required);

  licenseNumber: FormControl= this.fb.control('', [Validators.required]);
  ssn: FormControl = this.fb.control('', [Validators.required, Validators.minLength(4)]);
  dob: FormControl= this.fb.control('', [Validators.required, Validators.pattern("[0-9]{1,2}/[0-9]{1,2}/[0-9]{4}")]);

  //, Validators.minLength(10), Validators.pattern("(?:(?:0[1-9]|1[0-2])[\/\\-. ]?(?:0[1-9]|[12][0-9])|(?:(?:0[13-9]|1[0-2])[\/\\-. ]?30)|(?:(?:0[13578]|1[02])[\/\\-. ]?31))[\/\\-. ]?(?:19|20)[0-9]{2}")

  submittedLogin:boolean = false;
  submittedFTReset:boolean = false;

  userMessages: Array<MessageModel> = [];
  errorMessage:boolean = false;

  loading: boolean = false;
  returnUrl: string;
  public isConnected: boolean = false;
  public login: boolean = true;
  public passwordReset: boolean = true;
  loginResponseStatus: number;
  validateUserWithPersInfoRespStatus: number;
  
isReset: any;
  
  ipAddress: string;
  loginRequestModel: ValidateUserWithPasswordRequestModel = new  ValidateUserWithPasswordRequestModel (); 
  userInformationsModel : ValidateUserWithPersonalInformationRequestModel = new ValidateUserWithPersonalInformationRequestModel();
    
  constructor(private messageCenter: MessageCenter,
    private loginService: LoginService,
    private fb: FormBuilder,
    private currentPageWatcherService: CurrentPageWatcherService,
    private router : Router,
    private spinner: SpinnerService,
    private transactionService : TransactionsService,
    private storageService : StorageService,
    private activeRoute: ActivatedRoute) {
      this.currentPageWatcherService.sendStepMessage(null);

    }
  ngOnInit() {
    this.storageService.clear();
    this.errorMessage = false;

      this.ipAddress = '0.0.0.0';

    
    this.currentPageWatcherService.pageChanged().emit("Real Estate Licensing Login");
    this.currentPageWatcherService.notifyLeftMenuDisplay().emit(false);
    this.loginform = this.fb.group({
      userName: this.userName,
      password: this.password
    });

    this.firstTimeResetform = this.fb.group({ licenseNumber: this.licenseNumber, ssn: this.ssn, dob: this.dob });
    this.isReset=this.activeRoute.snapshot.paramMap.get("id");
    if(this.isReset==''){
      this.login=true;
    }else{
      this.firstTime(this.firstTimeResetform);
    }



  }

  onFirstTimeResetSubmit(form:NgForm){
    console.log("form : ", form);
    let formData = form.value;
    console.log(form);
    this.currentPageWatcherService.clearUserMessage();
    this.userMessages = [];
    this.submittedFTReset = true;
    this.loading = true;
      this.userInformationsModel.birthDate=formData.dob;
      this.userInformationsModel.ssnSuffix=formData.ssn;
      this.userInformationsModel.licenseNo=formData.licenseNumber;
      this.userInformationsModel.passwordReset=this.passwordReset;
      this.userInformationsModel.visitorIPAddress = this.ipAddress;
      console.log( this.userInformationsModel);
     // this.checkDate();
     this.spinner.show();

     if(!form.valid){
      this.spinner.hide();
     }else{
      this.loginService.validateUserWithPersonalInfomation(this.userInformationsModel)
    .subscribe(resp =>{
      console.log("Login with personal info ",resp);
      if(resp.UserMessages!=undefined){
        
        resp.UserMessages.forEach(el=>{
           this.userMessages.push(el);
           this.spinner.hide();
       });
       this.currentPageWatcherService.sendUserMessages(this.userMessages);
     }
      
    
      if (resp.Summary == 0) {
        if (this.passwordReset) {
          this.resetPassword(resp);
        }
        else {
          let token = (resp && resp.SecurityToken);
          let userSessionId: number
          if (token) {
            userSessionId = resp.SessionID;
            this.firstTimeLogin(token, userSessionId, resp.UserID);
          }
        }
        this.userMessages = [];

      }
      else {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.userMessages = [];
        this.spinner.hide();
       

    }
    },
    (err) => {
      if (err.error && err.error.UserMessages != undefined) {
        err.error.UserMessages.forEach(element => {
          this.userMessages.push(element)
        });
       
      }
      else {
        let userMsg : MessageModel;
        userMsg.Alert=3;
        userMsg.Description=err.message; 
        this.userMessages.push(userMsg);

      }
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.currentPageWatcherService.sendUserMessages(this.userMessages);
      this.spinner.hide();
    }
  );
   
     }  
  }

 

  loginUser(formData){

    this.loginRequestModel.licenseNo = formData.userName;
    this.loginRequestModel.password = formData.password;
    this.loginRequestModel.visitorIPAddress = this.ipAddress;
    this.loading = true;
    let res :any;
    // if (this.loginform.valid) {
     
      this.spinner.show();

    
     
      this.loginService.login(this.loginRequestModel).subscribe(data =>
        { 
             console.log("login resp:: ",data.json());
             if(data.json().UserMessages!=undefined){
        
              data.json().UserMessages.forEach(el=>{
                 this.userMessages.push(el);
             });
           }
        this.currentPageWatcherService.sendUserMessages(this.userMessages);
             //no error 
        if (data.json().Summary == 0) {
          let userInfo : ValidateUserResponseModel = data.json();
          userInfo.LicenseNo = this.loginRequestModel.licenseNo;
          this.loginService.onLogin.emit(userInfo);
          this.loading = false;
          this.userMessages = [];

        }
         else{
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        
        }
        }
        , (err) => { 
            console.log("error !! ",err.json());
            this.handleLoginFailure(err);
         });

     
  }

  firstTimeLogin(token, userSessionId, userId){
    console.log("this is first time login");
    this.loginService.validateUserFirstTimeLogin(token, userSessionId);
    this.loading = true;
    this.getUserRequiredInfoForward(userId);
  }

  resetPassword(resp : ValidateUserResponseModel){
      console.log("this is reset");        
       window.open(resp.PasswordResetUrl, "_self");
    }
    
  
  
  handleLoginFailure(error){
    if (error.json() && error.json().UserMessages != undefined) {
      error.json().UserMessages.forEach(element => {
        this.userMessages.push(element)
      });
      
    }
    else {
      let userMsg : MessageModel;
      userMsg.Alert=3;
      userMsg.Description=error.message; 
      this.userMessages.push(userMsg)

    }
    $("html, body").animate({ scrollTop: 0 }, "slow");
      this.currentPageWatcherService.sendUserMessages(this.userMessages);
      this.spinner.hide();
      this.userMessages=[];
  }

  // getUserRequiredInfo(userId):RequiredInformationModel{
  //   let res: RequiredInformationModel={};
  //   this.loginService.getRequiredUserInformation(userId).subscribe(
  //     (result: RequiredInformationModel)=>{
  //       console.log(result);
  //       res = result;
  //     },
      
  //     (err)=>{
  //        if(err.status==404){
  //         this.messageCenter.showGrowl("error", "First time login error", "Required information not found for the userID");
  //         this.loading = false;
  //       }
  //       if(err.status==500){
  //         this.messageCenter.showGrowl("error", "First time login error", "ADRE application exception.");
  //         this.loading = false;
  //       }
  //       this.spinner.hide();
  //      // this.router.navigate(['/loginError']);
  //     }
  //   )
  //   return res;
  // }

  getUserRequiredInfoForward(userId){
    let res: RequiredInformationModel;
    this.loginService.getRequiredUserInformation(userId).subscribe(
      (result: RequiredInformationModel)=>{
        if(result){
          console.log(result);
            this.router.navigate(["/firstTimeLogin"])
            .then(()=>{
             this.loginService.notifyRequiredUserInformation.emit(result);
           }) ;
           this.loading = false;
        }
      },
      
      (err)=>{
         if(err.status==404){
          this.messageCenter.showGrowl("error", "First time login error", "Required information not found for the userID");
          this.loading = false;
        }
        if(err.status==500){
          this.messageCenter.showGrowl("error", "First time login error", "ADRE application exception.");
          this.loading = false;
        }
        this.spinner.hide();
       // this.router.navigate(['/loginError']);
      }
    )
   
        
    
  }

  onSubmit(form:NgForm) {
    this.submittedLogin = true;

    let formData = form.value;
       console.log(form);
       console.log(formData);

       if(!form.valid){
        this.spinner.hide();
      }else{
        this.loginUser(formData);
       }
  }


sub;

  firstTime(firstTimeResetform){
    this.sub=this.activeRoute.paramMap.subscribe(params => { 
      console.log(params);
       this.isReset = params.get('id'); 

       if(this.isReset!= undefined && this.isReset!= '' && this.isReset=='firstTime'){
        this.clearForm();
        this.userMessages.splice(0,this.userMessages.length);
        this.currentPageWatcherService.clearUserMessage();
        this.errorMessage=false;
        this.submittedLogin = false;
        this.submittedFTReset = false;
        firstTimeResetform.reset();
        this.firstTimeResetform.reset();
        
      
        this.login = false;
        this.passwordReset =false;
        }else if (this.isReset!= undefined && this.isReset!= '' && this.isReset=='reset'){
          this.clearForm();
          this.userMessages.splice(0,this.userMessages.length);
          this.errorMessage=false;
          this.currentPageWatcherService.clearUserMessage();
          this.submittedLogin = false;
          this.submittedFTReset = false;
          firstTimeResetform.reset();
          this.firstTimeResetform.reset();
          this.login = false;
          this.passwordReset =true;
        }
         
   });
   
    
  }

 

  signin(loginform){
    this.clearForm();
    this.errorMessage=false;
    this.firstTimeResetform.reset();
    this.currentPageWatcherService.clearUserMessage();
    this.userMessages.splice(0,this.userMessages.length);
    this.submittedLogin = false;
    this.submittedFTReset = false;
    loginform.reset();
    this.login = true;
  }


  clearForm() {

    this.loginform.reset({
      'userName':'',
      'password':''
         });

    this.firstTimeResetform.reset({
      'licenseNumber': '',
      'ssn': '',
      'dob': ''
    });
    }

  checkDate() {
    const dateSendingToServer = new DatePipe('en-US').transform(this.dob, 'dd/MM/yyyy')
    console.log(dateSendingToServer);
  }

  ngOnDestroy(): void {
    this.currentPageWatcherService.clearUserMessage();
   
  }
}


// WEBPACK FOOTER //
// ./src/app/login/login/login.component.ts